import React from "react";
import Laundry1 from "../../../assets/images/laundry-1.png";
import Laundry2 from "../../../assets/images/laundry-2.png";
import Laundry3 from "../../../assets/images/laundry-3.png";
import Washfold from "../../../assets/images/wash-fold.png";
import DryCleaning from "../../../assets/images/dry-cleaning.png";
import pickup from "../../../assets/images/pickup.png";

const LaundryService = () => {
  return (
    <section 
      id="services" 
      className="scroll-mt-[90px] w-full bg-[#F2F2F2] py-16 px-6 md:px-12 lg:px-[150px]"
    >
      {/* Main Container */}
      <div className="flex flex-col gap-12 lg:flex-row lg:gap-6">

        {/* ---------------- LEFT CONTENT ---------------- */}
        <div className="flex-1">

          <h2 className="text-4xl md:text-[54px] font-bold leading-tight text-gray-900">
            Our Laundry <br /> Service
          </h2>

          <p className="mt-4 text-gray-600 max-w-md text-[16px]">
            We offer a complete range of laundry and dry-cleaning solutions
            designed to make your life easier.
          </p>

          <div className="w-full mt-[45px]">
            <img
              src={Laundry1}
              alt="Hanging shirts"
              className="w-full h-64 sm:h-80 md:h-[236px] rounded-xl object-cover"
            />
          </div>

          <div className="grid grid-cols-2 gap-4 mt-6">
            <img
              src={Laundry2}
              className="w-full h-40 sm:h-48 md:h-[156px] rounded-xl object-cover"
              alt="Washing machine"
            />
            <img
              src={Laundry3}
              className="w-full h-40 sm:h-48 md:h-[156px] rounded-xl object-cover"
              alt="Washer dryer"
            />
          </div>
        </div>

        {/* ---------------- RIGHT SERVICE BOXES ---------------- */}
        <div className="flex flex-col flex-1 gap-8">
          
          <div className="flex flex-col gap-6 mt-6">
            {/* Card 1 */}
            <div className="p-4 transition bg-white border border-gray-100 shadow-lg rounded-[8px] hover:shadow-xl">
              <div className="flex items-start gap-4">
                <div className="flex items-center justify-center p-4">
                  <img src={Washfold} alt="Easy Booking Icon" className="object-contain w-16 h-16" />
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900">Easy Booking</h3>
                  <p className="mt-2 leadi[14pxng-relaxed text-[#505050] text-">
                    Schedule a laundry pickup effortlessly through our intuitive app  just a few taps and your order is set.
                  </p>
                </div>
              </div>
            </div>

            {/* Card 2 */}
            <div className="p-4 transition bg-white border border-gray-100 shadow-lg rounded-[8px] hover:shadow-xl">
              <div className="flex items-start gap-4">
                <div className="flex items-center justify-center p-4">
                  <img src={DryCleaning} alt="Quality & Trust Icon" className="object-contain w-20 h-20" />
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900">Quality & Trust</h3>
                  <p className="mt-3 leadi[14pxng-relaxed text-[#505050] text-">
                    We partner only with professional, highly-rated laundry vendors, so your clothes always get expert care and attention.
                  </p>
                </div>
              </div>
            </div>

            {/* Card 3 */}
            <div className="p-4 transition bg-white border border-gray-100 shadow-lg rounded-[8px] hover:shadow-xl">
              <div className="flex items-start gap-4">
                <div className="flex items-center justify-center p-4">
                  <img src={pickup} alt="Reliable Pick-up & Delivery Icon" className="object-contain w-16 h-16" />
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900">Reliable Pick-up & Delivery</h3>
                  <p className="mt-3 leadi[14pxng-relaxed text-[#505050] text-">
                    Choose convenient pick-up and drop-off times that fit your routine no more waiting or missed appointments.
                  </p>
                </div>
              </div>
            </div>
            
            {/* Card 4 */}
            <div className="p-4 transition bg-white border border-gray-100 shadow-lg rounded-[8px] hover:shadow-xl">
              <div className="flex items-start gap-4">
                <div className="flex items-center justify-center p-4">
                  <img src={pickup} alt="Custom Preferences Icon" className="object-contain w-20 h-20" />
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900">Custom Preferences</h3>
                  <p className="mt-3 leadi[14pxng-relaxed text-[#505050] text-">
                    Select services that match your needs — wash & fold, dry cleaning, ironing, or special garment care, all handled per your instructions.                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default LaundryService;
